import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import YoutubeVideo from './youtube-video';
import InstagramPost from './instagram-post';
import Title from './social-media-slider-title';
import './social-media-slider.scss';

const SocialMediaSlider = ({
    itemSize,
    youtubeVideoIds,
    instagramAlias,
    instagramPostIds,
    pageName,
    dispatch
}) =>
    (!!youtubeVideoIds && youtubeVideoIds.length > 0) || !!instagramAlias ? (
        <Fragment>
            <Title
                youtube={!!youtubeVideoIds && youtubeVideoIds.length > 0}
                instagramAlias={instagramAlias}
            />
            <div className="d-flex justify-content-center">
                <div className="social-media-slider pt-3 position-relative d-inline-flex justify-content-start flex-nowrap">
                    {youtubeVideoIds &&
                        youtubeVideoIds.map((youtubeVideoId, index) => (
                            <YoutubeVideo
                                key={index}
                                youtubeVideoId={youtubeVideoId}
                                pageName={pageName}
                                width={itemSize.width}
                                height={itemSize.height}
                                dispatch={dispatch}
                            />
                        ))}
                    {instagramPostIds &&
                        instagramPostIds.map((postId, index) => (
                            <InstagramPost
                                key={index}
                                postId={postId}
                                width={itemSize.width}
                                height={itemSize.height}
                            />
                        ))}
                </div>
            </div>
        </Fragment>
    ) : null;

SocialMediaSlider.defaultProps = {
    pageName: ''
};

SocialMediaSlider.propTypes = {
    itemSize: PropTypes.shape({
        height: PropTypes.number,
        width: PropTypes.number
    }).isRequired,
    youtubeVideoIds: PropTypes.arrayOf(PropTypes.string),
    instagramAlias: PropTypes.string,
    instagramPostIds: PropTypes.arrayOf(PropTypes.string),
    pageName: PropTypes.string
};

const mapStateToProps = (state, ownProps) => ({
    ...ownProps
});

export default connect(mapStateToProps)(SocialMediaSlider);
